// or — merged from the per-page files. This is the object the app
// consumes (flat key namespace); the page files are the source of truth.
import common from './common';
import home from './home';
import dashboard from './dashboard';
import market from './market';
import bazaar from './bazaar';
import register from './register';

const or = {
  ...common,
  ...home,
  ...dashboard,
  ...market,
  ...bazaar,
  ...register,
};

export default or;
